import api from './api';
import {
  RecruiterJob,
  RecruiterJobsListResponse,
  CreateRecruiterJobRequest,
  UpdateRecruiterJobRequest,
} from '@/types';

export interface RecruiterJobFilters {
  page?: number;
  limit?: number;
  search?: string;
  status?: 'DRAFT' | 'ACTIVE' | 'ARCHIVED';
}

export const recruiterJobService = {
  // List recruiter jobs
  async listJobs(filters?: RecruiterJobFilters): Promise<RecruiterJobsListResponse> {
    const response = await api.get('/v1/recruiter-jobs', { params: filters });
    return response.data;
  },

  // Get a single job by ID
  async getJob(jobId: string): Promise<RecruiterJob> {
    const response = await api.get(`/v1/recruiter-jobs/${jobId}`);
    return response.data;
  },

  // Create a new job
  async createJob(data: CreateRecruiterJobRequest): Promise<RecruiterJob> {
    const response = await api.post('/v1/recruiter-jobs', data);
    return response.data;
  },

  // Update an existing job
  async updateJob(jobId: string, data: UpdateRecruiterJobRequest): Promise<RecruiterJob> {
    const response = await api.patch(`/v1/recruiter-jobs/${jobId}`, data);
    return response.data;
  },

  // Delete a job
  async deleteJob(jobId: string): Promise<{ message: string; id: string }> {
    const response = await api.delete(`/v1/recruiter-jobs/${jobId}`);
    return response.data;
  },

  // Re-run AI extraction on a job
  async reprocessJob(jobId: string): Promise<RecruiterJob> {
    const response = await api.post(`/v1/recruiter-jobs/${jobId}/reprocess`, {});
    return response.data;
  },
};

export default recruiterJobService;
